import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCart = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.669 2.327a.734.734 0 0 0-.723-.61H.984a.733.733 0 0 1 0-1.467h.961a2.2 2.2 0 0 1 2.17 1.83l.436 2.563h16.232a1.467 1.467 0 0 1 1.423 1.823l-1.417 5.67a3.667 3.667 0 0 1-3.557 2.778H6.298l.395 2.322c.06.353.365.611.723.61h9.7a.733.733 0 1 1 0 1.468h-9.7a2.2 2.2 0 0 1-2.169-1.832l-.539-3.167a.717.717 0 0 1-.003-.022L2.669 2.327Zm3.38 11.12L4.8 6.11h15.983l-1.417 5.67a2.2 2.2 0 0 1-2.134 1.667H6.048Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.383 21.147a1.1 1.1 0 1 0-2.2 0 1.1 1.1 0 0 0 2.2 0ZM7.95 20.047a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2Z",
		fill: "currentColor"
	})]
});
export { SvgCart as ReactComponent };
